import { applyActionCode, getAuth } from "firebase/auth";
import React, { FC, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Alert, Stack } from "@mui/material";

import { useDialog } from "../../hooks/use-dialog";
import { pushError } from "../../slices/notifications";
import { useDispatch } from "../../store";
import { parseErrorCode } from "../../utils/firebaseErrorParser";
import PasswordResetForm, {
  PasswordResetFormParams,
} from "./PasswordResetForm";

const FirebaseHandlers: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = getAuth();
  const [pageError] = useState("");
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode");
  const actionCode = searchParams.get("oobCode");
  const passwordResetDialogHandlers = useDialog<PasswordResetFormParams>();

  useEffect(() => {
    if (mode === "resetPassword") {
      passwordResetDialogHandlers.handleOpen({
        actionCode: actionCode || "",
      });
    }

    if (mode === "verifyEmail") {
      applyActionCode(auth, actionCode || "")
        .then(() => {
          auth.currentUser?.reload();
          localStorage.setItem("redirectUrl", "");

          const continueUrl = searchParams.get("continueUrl");
          if (continueUrl) {
            location.href = continueUrl;
          } else {
            setTimeout(() => navigate("/login", { replace: true }), 500);
          }
        })
        .catch((error) => {
          dispatch(pushError(parseErrorCode(error)));
          navigate("/verify-email", { replace: true });
        });
    }
  }, []);

  return (
    <>
      {pageError && (
        <Stack direction="row" justifyContent="center">
          <Alert severity="error">{pageError}</Alert>
        </Stack>
      )}
      <PasswordResetForm dialog={passwordResetDialogHandlers} />
    </>
  );
};

export default FirebaseHandlers;
